import { relations, sql } from 'drizzle-orm';
import { boolean, index, integer, pgTable, serial, text, uniqueIndex, varchar } from 'drizzle-orm/pg-core';
import { typeIdDataType as typeId } from '../utils/typeid';
import { application } from './application';
import { EVENT_TYPES } from './event';
import { eventsToEndpoints } from './event-to-endpoint';
import { webhookEndpointAccountTarget } from './webhook-endpoint-account-target';

export const webhookEndpoint = pgTable(
  'webhook_endpoint',
  {
    id: serial().primaryKey(),
    public_id: typeId('webhookEndpoint', 'public_id').notNull(),
    enabled: boolean().default(true).notNull(),
    description: text(),
    url: text().notNull(),
    trigger_events: text()
      .array()
      .$type<(typeof EVENT_TYPES)[number][]>()
      .notNull()
      .default(sql`'{}'::text[]`),
    secret: varchar({ length: 36 }).notNull(),
    application_id: integer()
      .references(() => application.id, { onDelete: 'cascade' })
      .notNull(),
  },
  (t) => [
    uniqueIndex('webhook_endpoint_public_id_uq').on(t.public_id),
    index('webhook_endpoint_application_id_idx').on(t.application_id),
    index('webhook_endpoint_application_enabled_idx').on(t.application_id, t.enabled),
    index('webhook_endpoint_trigger_events_gin_idx').using('gin', t.trigger_events),
  ],
);

export const webhookEndpointsRelations = relations(webhookEndpoint, ({ many, one }) => ({
  eventsToEndpoints: many(eventsToEndpoints),
  accountTargets: many(webhookEndpointAccountTarget),
  application: one(application, { fields: [webhookEndpoint.application_id], references: [application.id] }),
}));
